/**
 * Background loads that fill a menu, a filter list or a count (M55: no silently ignored errors).
 * Use `.catch(quietly)` where a failure shouldn't stop the screen: a cancelled request is ignored,
 * anything else is counted so the shell can say that something here didn't load.
 */
import { useSyncExternalStore } from 'react';
import { classifyFailure } from '@miraops/contracts';

let failed = 0;
const listeners = new Set<() => void>();
const notify = () => { for (const listener of listeners) listener(); };

export function quietly(error: unknown): undefined {
  if (classifyFailure({ error, operation: 'read' }).kind !== 'cancelled') { failed += 1; notify(); }
  return undefined;
}
export const quietFailures = () => failed;
export function clearQuietFailures(): void { if (failed) { failed = 0; notify(); } }
const subscribe = (listener: () => void) => { listeners.add(listener); return () => { listeners.delete(listener); }; };
export const useQuietFailures = () => useSyncExternalStore(subscribe, quietFailures, quietFailures);
